import {
  StepTitle
} from '@roc/ui';

export default StepTitle;

export {
  StepTitle
} from '@roc/ui';
